import { useState } from "react";
import { useAdminAuth } from "../../../context/AdminAuthContext";

const LoginModal = () => {
  const { showLogin, setShowLogin, login, error, setError, checking } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  if (!showLogin) return null;

  async function handleSubmit(e) {
    e.preventDefault();
    const ok = await login(email, password);
    if (ok) {
      setEmail("");
      setPassword("");
    }
  }

  function close() {
    setShowLogin(false);
    setError("");
    setEmail("");
    setPassword("");
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm px-6">
      <div className="w-full max-w-sm border border-white/10 bg-black p-8">
        <div className="flex items-center justify-between mb-6">
          <div>
            <p className="text-[10px] uppercase tracking-[0.3em] text-red-600 font-semibold mb-1">
              Premium Admin
            </p>
            <h2 className="text-lg font-black text-white uppercase tracking-tight">
              Sign In
            </h2>
          </div>
          <button
            type="button"
            onClick={close}
            className="text-white/30 hover:text-white text-xl leading-none"
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-[10px] uppercase tracking-[0.25em] text-white/40 font-semibold mb-2">
              Email
            </label>
            <input
              type="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-white/5 border border-white/10 text-white placeholder-white/25 px-4 py-3 text-sm focus:outline-none focus:border-red-600 transition-colors duration-200"
            />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-[0.25em] text-white/40 font-semibold mb-2">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-white/5 border border-white/10 text-white placeholder-white/25 px-4 py-3 text-sm focus:outline-none focus:border-red-600 transition-colors duration-200"
            />
          </div>

          {error && (
            <p className="text-xs text-red-500" role="alert">{error}</p>
          )}

          <button
            type="submit"
            disabled={checking}
            className="w-full py-3 bg-red-700 hover:bg-red-600 disabled:opacity-40 text-white font-bold uppercase tracking-widest text-xs transition-colors duration-200"
          >
            {checking ? "Checking…" : "Unlock"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginModal;